import React, { useState } from "react";
import { Calendar, Clock, MapPin, Users, Heart, GraduationCap } from "lucide-react";
import "../../styles/Events/UpcomingEvents.css";

function UpcomingEvents() {
  const [volunteerForm, setVolunteerForm] = useState({
    name: "",
    email: "",
    phone: "",
    interests: "",
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const events = [
    {
      id: 1,
      title: "2026 Scholarships — Barbados",
      date: "May 1, 2026",
      time: "TBA",
      location: "TBA",
      description:
        "Scholarship opportunities are opening for students across three institutions in Barbados. Further details on eligibility, requirements, and application procedures for each institution are coming soon.",
      icon: <GraduationCap size={32} color="#00759a" />,
      institutions: [
        "1 Secondary School",
        "1 College",
        "1 University",
      ],
      tags: ["Barbados", "Scholarships", "Education"],
    },
    {
      id: 2,
      title: "2026 Scholarships — Canada",
      date: "May 1, 2026",
      time: "TBA",
      location: "TBA",
      description:
        "Scholarship opportunities are opening for students across two institutions in Canada. Further details on eligibility, requirements, and application procedures for each institution are coming soon.",
      icon: <GraduationCap size={32} color="#00759a" />,
      institutions: [
        "1 College",
        "1 University",
      ],
      tags: ["Canada", "Scholarships", "Education"],
    },
    {
      id: 3,
      title: "Human Rights Education Initiatives",
      date: "September 15, 2026",
      time: "TBA",
      location: "Community Centers",
      description:
        "Join us for our comprehensive Human Rights Education Initiatives program. This event focuses on promoting awareness, understanding, and advocacy for fundamental human rights within our communities.",
      icon: <Users size={32} color="#00759a" />,
      institutions: [],
      tags: ["Human Rights", "Education", "Community"],
    },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVolunteerForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a backend
    console.log("Volunteer form submitted:", volunteerForm);
    setSubmitStatus("success");

    // Reset form after submission
    setTimeout(() => {
      setVolunteerForm({
        name: "",
        email: "",
        phone: "",
        interests: "",
      });
      setSubmitStatus(null);
    }, 3000);
  };

  return (
    <div className="upcoming-events">
      <div className="container">
        <div className="section-header">
          <h1 className="section-title">Upcoming Events</h1>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Stay informed about our upcoming events and opportunities to make a
            difference in our community. Join us in our mission to create
            positive change.
          </p>
        </div>

        <div className="events-grid">
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <div className="event-icon">{event.icon}</div>
              <h2 className="event-title">{event.title}</h2>
              <div className="event-details">
                <div className="event-detail">
                  <Calendar size={18} />
                  <span>{event.date}</span>
                </div>
                <div className="event-detail">
                  <Clock size={18} />
                  <span>{event.time}</span>
                </div>
                <div className="event-detail">
                  <MapPin size={18} />
                  <span>{event.location}</span>
                </div>
              </div>
              <p className="event-description">{event.description}</p>
              {event.institutions.length > 0 && (
                <ul className="event-institutions">
                  {event.institutions.map((inst) => (
                    <li key={inst} className="event-institution-item">{inst}</li>
                  ))}
                </ul>
              )}
              <div className="event-tags">
                {event.tags.map((tag) => (
                  <span key={tag} className="event-tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="volunteer-section">
          <div className="volunteer-header">
            <h2 className="volunteer-title">
              <Heart size={36} color="#00759a" />
              Get Involved
            </h2>
            <p className="volunteer-subtitle">
              Become a volunteer and help us make a lasting impact in our
              community. Sign up to participate in community projects and
              events. Your time and dedication can transform lives.
            </p>
          </div>

          <form className="volunteer-form" onSubmit={handleSubmit}>
            {submitStatus === "success" && (
              <div className="success-message">
                Thank you for signing up! We will contact you soon with
                volunteer opportunities.
              </div>
            )}

            <div className="form-content">
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={volunteerForm.name}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={volunteerForm.email}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="your.email@example.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="form-label">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={volunteerForm.phone}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="(555) 123-4567"
                />
              </div>

              <div className="form-group">
                <label htmlFor="interests" className="form-label">
                  Areas of Interest *
                </label>
                <textarea
                  id="interests"
                  name="interests"
                  value={volunteerForm.interests}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="Tell us about your interests and how you'd like to contribute (e.g., education, community outreach, event planning, etc.)"
                  required
                ></textarea>
              </div>

              <div className="button-container">
                <button type="submit" className="submit-button">
                  <Users size={20} />
                  Sign Up to Volunteer
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpcomingEvents;
